import { MultiSelect, type MultiSelectProps } from "@mantine/core";

type WeekdayMultiSelect = Exclude<MultiSelectProps, "data">;

export function WeekdayMultiSelect({ ...props }: WeekdayMultiSelect) {
  return <MultiSelect data={SCHOOL_DAYS} {...props} />;
}

export const SCHOOL_DAYS = [
  { label: "Montag", value: "monday" },
  { label: "Dienstag", value: "tuesday" },
  { label: "Mittwoch", value: "wednesday" },
  { label: "Donnerstag", value: "thursday" },
  { label: "Freitag", value: "friday" },
];
